import { useEffect, useState } from 'react';
import { getFileFromFilename } from 'src/app/services/lead';

interface S3ImageProps {
    fileKey: string;
    alt?: string;
    className?: string;
    width?: number;
    height?: number;
    imageClassName?: string;
}

const ServerImage: React.FC<S3ImageProps> = ({ fileKey, alt = 'Image', className, imageClassName, width = 84, height = 84 }) => {
    const [imageUrl, setImageUrl] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchImageUrl = async () => {
            if (!fileKey) return;

            try {
                const response = await getFileFromFilename(fileKey);
                if (response) setImageUrl(response);
                else setImageUrl(fileKey);
            } catch (error) {
                console.error('Failed to fetch image URL:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchImageUrl();
    }, [fileKey]);

    return (
        <div className={className}>
            {loading ? (
                <div className={`bg-gray-200 animate-pulse ${imageClassName}`}></div>
            ) : (
                <img src={imageUrl} alt={alt} width={width} height={height} className={`object-cover ${imageClassName ? imageClassName : 'w-[84px] h-[84px] '}`} />
            )}
        </div>
    );
};

export default ServerImage;
